import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { authApiService } from '../services/authApiService'
import { colors, fontSize, radius, spacing } from '../styles/theme'

/**
 * Warns an admin without MFA how long they have before mandatory MFA blocks them (SOC 2 CC6.1).
 * Renders nothing once MFA is enabled or when MFA is never required for the account.
 */
export function MfaDeadlineBanner() {
  const [requiredBy, setRequiredBy] = useState<Date | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    authApiService.mfaStatus()
      .then(s => setRequiredBy(!s.isEnabled && s.requiredBy ? new Date(s.requiredBy) : null))
      .catch(() => setRequiredBy(null))
  }, [])

  if (!requiredBy) return null

  return (
    <div role="status" style={{
      background: colors.warningLight,
      color: colors.warning,
      borderBottom: `1px solid ${colors.warningBorder}`,
      padding: `${spacing.sm} ${spacing.lg}`,
      fontSize: fontSize.sm,
      display: 'flex', gap: spacing.md, alignItems: 'center', flexWrap: 'wrap',
    }}>
      <span style={{ flex: '1 1 260px' }}>
        Two-factor authentication is required for admin accounts
        {requiredBy > new Date() ? ` from ${requiredBy.toLocaleDateString()}` : ''}.
      </span>
      <button type="button" onClick={() => navigate('/app/settings?tab=mfa')} style={{
        padding: '4px 12px', background: colors.surface, color: colors.warning, border: `1px solid ${colors.warningBorder}`,
        borderRadius: radius.sm, fontSize: fontSize.sm, fontWeight: 600, cursor: 'pointer',
      }}>
        Set up two-factor authentication
      </button>
    </div>
  )
}
